import IconDetail from "@/components/common/IconDetail";
import type { ExtendedShockwaveViewT } from "@/types/database/events";
import { User, UserSquare } from "lucide-react";

interface Props {
    shockwave: ExtendedShockwaveViewT;
}

const ShockwaveMainInfo = ({ shockwave }: Props) => {
    return (
        <div className="flex flex-col gap-2">
            <IconDetail
                icon={<UserSquare size={16} />}
                words={`Referred by: ${
                    shockwave?.referring_clinician_name ?? "Unknown"
                }`}
            />
            {shockwave?.shockwaving_clinician_id && (
                <IconDetail
                    icon={<User size={16} />}
                    words={`Performed by: ${
                        shockwave?.shockwaving_clinician_name ?? "Unknown"
                    }`}
                />
            )}
        </div>
    );
};

export default ShockwaveMainInfo;
